import React from 'react'

import { classNames, typenameToClass } from '../ui/utils'

import type { MediaComponent } from './types'

import MediaSVGImageComponent, { MediaSVGImage } from './MediaSVGImage'
import MediaAPIImageComponent, { MediaAPIImage } from './MediaApiImage'
import MediaImageComponent, { MediaImage } from './MediaImage'
import MediaVideoComponent, { MediaVideo } from './MediaVideo'
import MediaVideoFileComponent, { MediaVideoFile } from './MediaVideoFile'

/**
 * Media field that can have different media types.
 */
export type DrupalMedia = MediaImage | MediaSVGImage | MediaVideo | MediaVideoFile | MediaAPIImage

interface Props extends React.HTMLProps<HTMLDivElement> {
	source?: DrupalMedia
	title?: string
}

type MediaLibraryType = { [key: string]: MediaComponent<any> }

/**
 * Supported media components.
 */
const MediaLibrary: MediaLibraryType = {
	media__api_image: MediaAPIImageComponent,
	media__image: MediaImageComponent,
	media__video: MediaVideoComponent,
	media__video_file: MediaVideoFileComponent,
	media__svg_image: MediaSVGImageComponent
}

function renderMedia(media: DrupalMedia, title?: string, className?: string) {
	const component = MediaLibrary[media.__typename]

	if (!component) {
		throw Error('Invalid media type')
	}

	return React.createElement(component, {
		className,
		media,
		title
	})
}

const Media: React.FC<Props> = ({ source, title, className, ...props }) => (
	<div className={classNames(className, 'media', source ? typenameToClass(source.__typename) : 'no-media')} {...props}>
		{source && renderMedia(source, title)}
	</div>
)

export default Media
